import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy, Checklist } from "@mui/icons-material";
import { POLICY_STATUS_DELETED } from "../Constants/PolicyTranslationConstants";
import { useWorkspace } from "context/WorkspaceContext";

const UseCasesActionsFragment = ({ editable, params }) => {
  const [useCase, setUseCase] = useState(
    params.row.RuleHeader?.UseCase === undefined ||
      params.row.RuleHeader?.UseCase !== "Complete"
      ? ""
      : "Complete"
  );
  const { workspaceController, setWorkspaceController } = useWorkspace();

  const copyDiagnosisListExpandedToClipboad = (DiagnosisListExpanded) => {
    if (DiagnosisListExpanded) {
      navigator.clipboard.writeText(DiagnosisListExpanded);
    }
  };

  const handleUseCaseChange = () => {
    const index = params.row.index;

    if (useCase === "Complete") {
      workspaceController.setUseCase(index, "");
    } else {
      workspaceController.setUseCase(index, "Complete");
    }
    const clonedWorkSpaceController = workspaceController.cloneController();
    setWorkspaceController(clonedWorkSpaceController);
  };

  const useCaseColor =
    params.row.RuleHeader?.UseCase === undefined ||
    params.row.RuleHeader?.UseCase !== "Complete"
      ? "default"
      : "useCaseComplete";

  return (
    <>
      {(params.row.RuleHeader.EditRule ?? "").toUpperCase() !==
        POLICY_STATUS_DELETED && (
        <>
          <Tooltip title="Copy Diagnoses">
            <IconButton
              disabled={!editable}
              onClick={() => {
                copyDiagnosisListExpandedToClipboad(
                  params.row.RuleFacts.DiagnosisListExpanded
                );
              }}
            >
              <ContentCopy />
            </IconButton>
          </Tooltip>
        </>
      )}
      <Tooltip title="Complete">
        <IconButton
          disabled={!editable}
          color={useCaseColor}
          onClick={handleUseCaseChange}
        >
          <Checklist />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default UseCasesActionsFragment;
